const progressBarTrack = document.querySelector('.progress-bar-track');
const progressBarTextValue = document.querySelector('.progress-text-value');

// duplicated
const numberOfQuestions = Number(
  document.querySelector('.step-panel-tab-pane-wrapper').dataset
    .numberOfQuestions
);

// formerly named / came from "tabsRenderStepCompletionProgress" in the old codebase
/**
 * Renders the green "complete" dots and bars that show up in the tabs / breadcrumbs.
 * @param {Number} progress - A number indicating the step/question the user is "on"
 */
function renderProgressBarProgress(progress) {
  if (!progress) {
    progress = 1;
  }

  const progressPctg = Math.round(((progress - 1) / numberOfQuestions) * 100);
  // console.log('progressPctg: ', progressPctg);

  // TODO: do this in a more LERPy way
  progressBarTrack.style.setProperty('--progress', progressPctg);
  progressBarTextValue.dataset.progress = progressPctg;
}

export default renderProgressBarProgress;
